import React from "react";
import { Github, GitFork, Heart, Scale } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/i18n";

const cardIcons = [Scale, Heart, GitFork];

const OpenSourceSection = () => {
  const { t } = useLanguage();
  const cards = t('openSource.cards');

  return (
    <section className="py-20 sm:py-28 px-4 relative overflow-hidden">
      {/* Background accent */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/5 to-transparent pointer-events-none" />
      
      <div className="max-w-5xl mx-auto relative z-10">
        {/* Section header */}
        <div className="text-center mb-16 space-y-4">
          <span className="text-primary text-sm font-medium uppercase tracking-widest">
            {t('openSource.label')}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground">
            {t('openSource.title')}{" "}
            <span className="text-gradient">{t('openSource.titleHighlight')}</span>
          </h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">
            {t('openSource.description')}
          </p>
        </div>

        {/* Cards */}
        <div className="grid sm:grid-cols-3 gap-6">
          {cards.map((card, index) => {
            const Icon = cardIcons[index];
            const colors = ["bg-primary/10 text-primary", "bg-secondary/10 text-secondary", "bg-accent/10 text-accent"];
            return (
              <div key={index} className="glass-card rounded-2xl p-8 text-center hover:border-primary/30 transition-colors duration-300">
                <div className={`w-14 h-14 rounded-2xl ${colors[index].split(' ')[0]} flex items-center justify-center mx-auto mb-5`}>
                  <Icon className={`w-7 h-7 ${colors[index].split(' ')[1]}`} />
                </div>
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  {card.title}
                </h3>
                <p className="text-muted-foreground text-sm">
                  {card.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* GitHub CTA */}
        <div className="mt-12 text-center">
          <Button variant="hero-outline" size="lg" asChild>
            <a
              href="https://github.com/ajamaica/lumiere"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2"
            >
              <Github className="w-5 h-5" />
              {t('openSource.viewOnGithub')}
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default OpenSourceSection;
